import {axiosInstance} from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const contactUs = catchAsync(async (body) => {
  const { data } = await axiosInstance.post("contacts", body);
  return data;
});
